import React, { useState } from 'react';
import "../styles/StaffApply.css";

const BugReport = () => {
  const [formData, setFormData] = useState({
    name: '',
    discord: '',
    bugDescription: '',
    stepsToReproduce: '',
  });
  const [successMsg, setSuccessMsg] = useState('');

  const handleChange = e => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const webhookURL = 'https://discord.com/api/webhooks/1375116821811691550/NBjIV6UOdWoCBI1rKJ2XBg0hrCvICj_FCe3CbTYzMLjPm1KMKsPPlgE6kJ5B5aqBG5TB';

    const payload = {
      username: "RixxyMC Bot",
      embeds: [
        {
          title: "🐞 New Bug Report",
          color: 15158332, // red-ish
          fields: [
            { name: "👤 Minecraft Username", value: formData.name },
            { name: "💬 Discord Tag", value: formData.discord },
            { name: "🐛 Bug Description", value: formData.bugDescription },
            { name: "🛠️ Steps to Reproduce", value: formData.stepsToReproduce },
          ],
          footer: { text: "RixxyMC Bug Reporting System" },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMsg("✅ Bug report sent successfully!");
        setFormData({ name: '', discord: '', bugDescription: '', stepsToReproduce: '' });
      } else {
        setSuccessMsg("❌ Failed to send. Check webhook URL.");
      }
    } catch (err) {
      console.error(err);
      setSuccessMsg("❌ Error sending bug report.");
    }
  };

  return (
    <div className="container">
      <h2>RixxyMC Bug Report</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Minecraft Username:</label>
        <input id="name" type="text" value={formData.name} onChange={handleChange} required />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input id="discord" type="text" value={formData.discord} onChange={handleChange} required />

        <label htmlFor="bugDescription">Bug Description:</label>
        <textarea id="bugDescription" rows="4" value={formData.bugDescription} onChange={handleChange} required />

        <label htmlFor="stepsToReproduce">Steps to Reproduce:</label>
        <textarea id="stepsToReproduce" rows="4" value={formData.stepsToReproduce} onChange={handleChange} required />

        <button type="submit">Submit Bug Report</button>
        {successMsg && <div className="success">{successMsg}</div>}
      </form>
    </div>
  );
};

export default BugReport;
